import BaseComponent from '../base-component/base-component'
import { bodyElement } from '../../components/common/body-element'
import { checkEnterKey } from '../../utils/utils'
import { parseHTML } from '../../utils/dom'
import Pagination from './pagination'

class PaginationLoadButton extends BaseComponent {
  connectedCallback(): void {
    this.addEventListener('keydown', this.handleKeyDown)
    this.addEventListener('click', this.handleButtonClick)
  }

  disconnectedCallback(): void {
    this.removeEventListener('keydown', this.handleKeyDown)
    this.removeEventListener('click', this.handleButtonClick)
  }

  handleButtonClick = (): void => {
    this.fetchResults()
  }

  handleKeyDown = (event: KeyboardEvent): void => {
    const isEnterKey = checkEnterKey(event.key || event.keyCode)

    if (isEnterKey) {
      event.preventDefault()

      this.fetchResults()
    }
  }

  fetchResults(): void {
    const url = this.dataset.url

    if (url) {
      this.setLoadingStatus(true)

      fetch(url)
        .then(response => response.text())
        .then(responseText => {
          const html = parseHTML(responseText)

          this.setLoadingStatus(false)
          this.updateFromHTML(html)
          this.updatePaginationFromHTML(html)
        })
        .catch(() => {
          if (!bodyElement.notification) {
            return
          }

          bodyElement.notification.show(
            'Error in pagination load button component',
            'warning',
          )
        })
    }
  }

  updatePaginationFromHTML(html: Document): void {
    const pagination = this.closest<Pagination>('pagination-component')

    if (pagination) {
      pagination.updateTargetsFromHTML(html)
      pagination.updateFromHTML(html)
    }
  }

  setPaginationUrl(newBtn: HTMLElement): void {
    this.dataset.url = newBtn.dataset.url
  }

  removePagination(): void {
    const pagination = this.closest<Pagination>('pagination-component')

    if (pagination) {
      pagination.remove()
    }
  }

  updateFromHTML(html: Document): void {
    const newBtn = html.querySelector<PaginationLoadButton>(
      'pagination-load-button',
    )

    if (newBtn) {
      this.setPaginationUrl(newBtn)
    } else {
      this.removePagination()
    }
  }

  setLoadingStatus(isLoading: boolean): void {
    this.toggleAttribute('disabled', isLoading)
    this.classList.toggle('loading', isLoading)
  }
}

export default PaginationLoadButton
